module.exports = __webpack_public_path__ + "static/media/give4forestFooter.2056e8a8.svg";